import { SYM_METHOD } from "../enum/Symbol";
import useDiscard from "../useDiscard";
import useSymbolProp from "../useSymbolProp";
import useMap from "./useMap";
import useWeakMap from "./useWeakMap";

const store = useWeakMap();

const onDiscardProp = (props) => store.delete(props);

const createIfNotExist = (props) => {
    if (!store.has(props)) {
        store.set(props, useMap());
        useDiscard(props, onDiscardProp);
    }
    return store.get(props);
}

const useInjectMethod = (props, methods) => {
    const methodStored = createIfNotExist(props);
    for (let k in methods) {
        if (k in methodStored) {
            throw `Method ${k} alrealy injected`
        }
        // methodStored[k] = methods[k];
        methodStored.set(k, methods);
    }
}

export const checkInjectionMethod = (props, name) => {
    return store.get(props) && store.get(props).get(name) && typeof store.get(props).get(name)[name] === 'function';
}

export const getInjectionMethods = (props) => {
    return store.get(props);
}

export const getInjectionMethodByName = (props, name) => {
    if (!checkInjectionMethod(props, name)) return null;
    return store.get(props)?.get(name)[name]
}

export const callInjectionMethod = (props, name, args) => {
    const method = getInjectionMethodByName(props, name);
    if (typeof method === 'function') {
        method.apply(method, args);
    }
}

export const setLinkingMethod = (fromProps, destProps) => {
    if (store.has(fromProps)) {
        store.set(destProps, store.get(fromProps));
    }
}

export default useInjectMethod;